import React, { useState } from 'react';

import Select, { components } from "react-select";

import styles from '@/views/components/SearchInputWithSelect/SearchInputWithSelect.module.scss';

export const Option = (props) => {
	return (
		<components.Option { ...props }>
			<div style={ { display: 'flex', flexDirection: 'row' } }>
				{props.isSelected && <div className='icon-accept' />}
				{props.data.label}
			</div>
		</components.Option>
	);
};
export const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator { ...props }>
			<div className='icon-arrow-down-full arrow' />
		</components.DropdownIndicator>
	);
};
export const ClearIndicator = props => {
	return (
		<components.ClearIndicator { ...props }>
			<div className={ styles[`custom-select--clear`] }>
				<i className='icon-close icon' />
			</div>
		</components.ClearIndicator>
	);
};

export const NoOptionsMessage = props => {
	return (
		<components.NoOptionsMessage { ...props }>
			<span>Brak elementów</span>
		</components.NoOptionsMessage>
	);
};

const SearchInput = ({ label, placeholder, searchedValue, value, setValue, searchFunction, options, selectValue, onSelectChange, disabled }) => {
	const [ isMenuOpened, setIsMenuOpened ] = useState(false);

	const clearValue = () => {
		setValue("");
		searchFunction("");
	};

	return (
		<div className={ styles['searchbar--item'] }>
			<label className={ styles['searchbar--label'] }>{label}</label>
			<div className={ styles['searchbar--bar'] }>
				<Select
					isClearable={ false }
					options={ options }
					value={ selectValue }
					onChange={ onSelectChange }
					className={  isMenuOpened ? 'custom-select-search--filters-select--menu-opened' : ''  }
					classNamePrefix={ 'custom-select-search--filters-select' }
					components={ {
						IndicatorSeparator: () => null,
						DropdownIndicator,
						ClearIndicator,
						NoOptionsMessage,
						Option,
					} }
					onMenuOpen={ () => setIsMenuOpened(true) }
					onMenuClose={ () => setIsMenuOpened(false) }
					fullwidth
					isDisabled={ disabled }
				/>
				<input
					placeholder={ placeholder }
					className={ styles['searchbar--input'] }
					type='text'
					name='query'
					value={ value }
					onChange={ (ev) => setValue(ev.target.value) }
					onKeyPress={ (ev) => {
						if (ev.charCode === 13) {
							searchFunction(value);
						}
					} }
					disabled={ disabled }
				/>
				<button
					className={ (searchedValue.length === 0 && value.length === 0 || disabled) ? `${ styles['searchbar--input-clear'] } ${ styles['disabled'] }` : styles['searchbar--input-clear'] }
					onClick={ clearValue }
				>
					<i className='icon-close icon' />
				</button>
				<div
					className={ (searchedValue === value || disabled) ? `${ styles['searchbar--input-submit'] } ${ styles['disabled'] }` : styles['searchbar--input-submit'] }
					onClick={ () => searchFunction(value) }
				>
					<i className='icon-search icon' />
				</div>
			</div>
		</div>
	);
};

export default SearchInput;